/**
 * @description singleton decorator
 * @param target The class prototype
 * @param _args The arguments
 * @returns The target
 * @example
 * \@singleton
 * class Test {}
 * const test = Test.getInstance();
 * const test2 = new Test();
 * test === test2 // true
 */
export function singleton(ctr) {
    let instance;
    return class {
        constructor(...args) {
            if (instance) {
                return instance;
            }
            instance = new ctr(...args);
            return instance;
        }
    };
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic2luZ2xldG9uLmRlY29yYXRvci5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9kZWNvcmF0b3JzL3NpbmdsZXRvbi5kZWNvcmF0b3IudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7O0dBV0c7QUFDSCxNQUFNLFVBQVUsU0FBUyxDQUF3QyxHQUFNO0lBQ3JFLElBQUksUUFBVyxDQUFDO0lBQ2hCLE9BQU87UUFDTCxZQUFZLEdBQUcsSUFBVztZQUN4QixJQUFJLFFBQVEsRUFBRSxDQUFDO2dCQUNiLE9BQU8sUUFBUSxDQUFDO1lBQ2xCLENBQUM7WUFFRCxRQUFRLEdBQUcsSUFBSSxHQUFHLENBQUMsR0FBRyxJQUFJLENBQUMsQ0FBQztZQUM1QixPQUFPLFFBQVEsQ0FBQztRQUNsQixDQUFDO0tBQ0csQ0FBQztBQUNULENBQUMifQ==